<template>
    <div class="row venue-event">
        <div class="col col-12 col-md-5 col-lg-4 col-xl-3 col-venue">
            <div class="card hg-topline" :style="topLineOverride">
                <img
                    v-if="event.image1"
                    class="img-fluid"
                    alt="Logo"
                    style="margin: 5px; margin-bottom: 15px; max-height: 200px"
                    :src="logoFileURL"
                />

                <div class="card-body">
                    <div class="text-left">
                        <table class="wordBreak">
                            <tr v-if="!event.remove_location">
                                <td>
                                    <i
                                        class="fa fa-map"
                                        style="padding-right: 17px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.location }}</td>
                            </tr>
                        </table>
                        <table v-if="showAddress">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-road"
                                        style="padding-right: 17px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.event_address.address1 }}</td>
                            </tr>
                        </table>
                        <table v-if="showAddress">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-building"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.event_address.city }}</td>
                            </tr>
                        </table>
                        <table v-if="showAddress">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-map-marker"
                                        style="padding-right: 25px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.event_address.postcode }}</td>
                            </tr>
                        </table>

                        <table v-if="showAddress && event.event_address.county">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-map-marker"
                                        style="padding-right: 25px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.event_address.county }}</td>
                            </tr>
                        </table>

                        <table
                            v-if="
                                showAddress && event.event_address.country_code
                            "
                        >
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-flag"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ countryName }}</td>
                            </tr>
                        </table>
                    </div>
                    <hr v-if="!event.remove_location" />

                    <div v-if="!datesEqual">
                        <table class="datesEqual">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-calendar"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>
                                    <strong>From: </strong>
                                    <p
                                        style="
                                            margin-bottom: 0px;
                                            font-size: 14px;
                                        "
                                    >
                                        {{ event.datetimefrom | formatDate }} @
                                        {{ event.datetimefrom | formatTime }}
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <i
                                        class="fa fa-calendar-o"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>
                                    <strong>To: </strong>
                                    <p
                                        style="
                                            margin-bottom: 0px;
                                            font-size: 14px;
                                        "
                                    >
                                        {{ event.datetimeto | formatDate }} @
                                        {{ event.datetimeto | formatTime }}
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div v-if="datesEqual">
                        <table class="datesEqual">
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-calendar"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>{{ event.datetimefrom | formatDate }}</td>
                            </tr>
                            <tr>
                                <td>
                                    <i
                                        class="fa fa-clock-o"
                                        style="padding-right: 20px"
                                        aria-hidden="true"
                                    ></i>
                                </td>
                                <td>
                                    {{ event.datetimefrom | formatTime }} -
                                    {{ event.datetimeto | formatTime }}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <p style="margin-bottom: 4em">
                        <a
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            class="btn btn-sm btn-primary"
                            style="margin: 10px 0; float: left"
                            :href="mailto"
                        >
                            Email Organiser</a
                        >
                    </p>
                    <div>
                        <social-circles
                            v-if="event.id != 2912"
                            :event="event"
                        ></social-circles>
                    </div>
                </div>
            </div>
        </div>
        <div class="col col-12 col-md-7 col-lg-8 col-xl-9 col-event">
            <div class="card hg-topline" :style="topLineOverride">
                <div class="card-body">
                    <div class="row">
                        <div class="col col-12 col-md-8">
                            <h3>
                                <strong :style="{ color: event.phcolour }">{{
                                    event.title
                                }}</strong>
                            </h3>

                            <div
                                style="
                                    background-color: #fff;
                                    border: 0;
                                    padding: 0px;
                                    margin-bottom: 20px;
                                "
                                :class="event.theme"
                            >
                                <h4 :style="{ color: event.phcolour }">
                                    About the event:
                                </h4>
                            </div>

                            <div
                                id="test"
                                style="border: 0; padding: 0px"
                                :style="{ color: event.textcolour }"
                                v-html="eventDetailsModified"
                            ></div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div align="center" v-if="imageFileURL">
                                <img
                                    alt="Event Image"
                                    class="img-fluid"
                                    style="margin-bottom: 15px"
                                    :src="imageFileURL"
                                />
                            </div>

                            <h6
                                v-if="!event.remove_location"
                                :style="{ color: event.phcolour }"
                            >
                                Venue - {{ event.location }}
                            </h6>

                            <div
                                style="width: 100%; height: 50%"
                                v-if="
                                    !event.international &&
                                    !event.remove_location
                                "
                            >
                                <google-map
                                    name="previewmap"
                                    :postcode="event.event_address.postcode"
                                ></google-map>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import maps from '@/common/maps.vue';
import moment from 'moment';
import socialCircles from '@/book/common/social-circles.vue';
import countries from '@/book/common/countries';

export default {
    data() {
        return {
            eventDetailsModified: '',
        };
    },
    props: [
        'event',
        'lat',
        'lng',
        'imageBucket',
        'imageFileURL',
        'logoFileURL',
    ],

    mixins: [countries],

    created() {
        this.eventDetailsModified = this.event.details.replaceAll(
            '<p><br></p>',
            '<br>'
        );
    },

    computed: {
        showAddress() {
            return !this.event.remove_location && this.event.event_address;
        },

        countryName() {
            if (
                this.event.event_address &&
                this.event.event_address.country_code
            ) {
                return this.getCountryName(
                    this.event.event_address.country_code
                );
            } else {
                return '';
            }
        },

        topLineOverride() {
            return { borderTop: '4px solid ' + this.event.phcolour };
        },

        mailto() {
            return (
                'mailto:' +
                this.event.organiser_email +
                '?Subject=Query%20about%20' +
                this.event.title
            );
        },

        datesEqual() {
            return moment
                .parseZone(this.event.datetimefrom)
                .isSame(moment.parseZone(this.event.datetimeto), 'day');
        },
    },

    components: {
        'google-map': maps,
        'social-circles': socialCircles,
    },
};
</script>

<style scoped>
.wordBreak {
    word-break: break-word;
}
</style>

